import React, { useCallback, useEffect } from 'react';

export const Context = React.createContext();

const data = {};

export function AnalyticsContextProvider(props) {
  useEffect(() => {
    global.analytics?.addSourceMiddleware?.(analyticsContextMiddleware);
  }, []);
  const [state, setState] = React.useState({});
  const setValue = useCallback((value, merge) => {
    setState((prev) => {
      const newValue = merge ? { ...prev, ...value } : value;
      data.value = newValue;
      return newValue;
    });
  }, []);
  return <Context.Provider value={{ value: state, setValue }} {...props} />;
}

function analyticsContextMiddleware({ payload, next }) {
  if (data.value) {
    payload.obj.properties = { ...data.value, ...payload.obj.properties };
  }
  next(payload);
}
